import React from "react";

function FacilitiesChart() {
  return (
    <div>
      <h2>Facilities Chart</h2>
      <p>Chart will be displayed here.</p>
    </div>
  );
}

export default FacilitiesChart;
